module.exports = __webpack_public_path__ + "assets/img/blender.72341054.png";